<template>
    <div class="page-notice">
        <component :is="homeConponent">
        </component>
    </div>
</template>

<script>
import {buildTdk} from '@config/tdk';
import SectionLine from './sections/line.vue';  // hyc
import hzyc from './sections/hzyc.vue';

export default {
    head() {
        var tdk = (buildTdk('help'));
        tdk.title = tdk.title + '·' + tdk.webName;
        return tdk
    },
    components: {
        SectionLine,
        hzyc,
    },
    data () {
        return {
            homeConponent:null,
        };
    },
    created() {
        let com = SectionLine;

        if (this.webInfo.id === 'hzc') {
            com = SectionLine;
        } else {
            com = hzyc;
        }

        this.homeConponent = com;
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
</style>